import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useSetGamblingSessionLimits = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetSessionLimitsRequestData) => {
        const { data } = await send<Types.ISetSessionLimitsRequestData & { scope: string }, Types.ISetSessionLimitsResponseData>({
            ID: 35902,
            responses: [35903, 35904],
            errorLevel: 1,
            scope: 'root',
            description: 'Set gambling session limits',
            ...request
        });

        return { sessionStartTime: data.sessionStartTime };
    }, [send]);
};
